import AbstractApiModel from '@/models/abstracts/AbstractApiModel';
import doc from '@model-core/decorators/doc';
import TeamModel from '@/models/entities/TeamModel';
import type { SummarySpec } from '@/models/summaries';

/**
 * Compteurs d'une équipe (GET /team_summaries, lecture seule, lisible comme l'équipe) : membres actuels, manager compris,
 * tenus par l'API. Ressource à part entière (comme les *Summary d'Igienair), demandée par l'écran pour sa page
 * (fetchSummaries, filtre team[]=…) ; team réduite à son identité.
 */
export default class TeamSummaryModel extends AbstractApiModel {
  protected _path = '/team_summaries/{?id}';

  declare _tsFilters: { team?: id | id[] };

  @doc.model(() => TeamModel) declare team: TeamModel;
  @doc.number declare activeMemberCount: number;
}

/** Résumés des équipes : TeamModel.teamSummary */
export const TEAM_SUMMARIES: SummarySpec = { model: TeamSummaryModel, parent: 'team', property: 'teamSummary' };
